import noop from 'lodash/noop';
import { Actionsheet, Box, Heading, IActionsheetProps, Pressable } from 'native-base';
import { ReactNode } from 'react';
import { Platform } from 'react-native';

import { Cross } from 'app/components/icons';

export type CPActionSheetProps = IActionsheetProps & {
  children?: ReactNode;
  isOpen: boolean;
  showHeader?: boolean;
  closeOnOverlayPress?: boolean;
  onClose?: () => void;
  title?: string;
};

export default function CPActionSheet({
  children,
  isOpen,
  onClose,
  showHeader = true,
  closeOnOverlayPress = true,
  title,
  ...props
}: CPActionSheetProps) {
  return (
    <Actionsheet
      _backdrop={closeOnOverlayPress ? undefined : { onPress: noop }}
      hideDragIndicator
      isOpen={isOpen}
      useRNModal={Platform.OS === 'ios'}
      onClose={onClose}
      {...props}
    >
      <Actionsheet.Content borderTopRadius={16} pb={8} pt={6} px={4}>
        {showHeader === true && (
          <Box alignItems="center" flexDirection="row" mb={4} width="100%">
            {title ? (
              <Heading color="black" flex={1} fontSize="xl" mr={4}>
                {title}
              </Heading>
            ) : null}
            <Pressable ml="auto" p="1" onPress={onClose}>
              <Cross size={24} />
            </Pressable>
          </Box>
        )}
        {children}
      </Actionsheet.Content>
    </Actionsheet>
  );
}
